import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const HierLduplicateIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 0H10C9.45 0 9 0.45 9 1V5H1C0.45 5 0 5.45 0 6V23C0 23.55 0.45 24 1 24H14C14.55 24 15 23.55 15 23V19H23C23.55 19 24 18.55 24 18V1C24 0.45 23.55 0 23 0ZM13 22H2V7H9V18C9 18.55 9.45 19 10 19H13V22ZM22 17H11V2H22V17Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

HierLduplicateIcon.displayName = 'HierLduplicateIcon';
